import React from 'react';

function MsaLogo() {
  return (
    <img
      src="/index/logo.png"
      alt="MSA Porta Paletes"
      style={{ height: '52px', width: 'auto', display: 'block' }}
    />
  );
}

export default MsaLogo;
